import { render, staticRenderFns } from "./SelectedLabelFilter.vue?vue&type=template&id=73027f96&scoped=true&"
import script from "./SelectedLabelFilter.vue?vue&type=script&lang=ts&"
export * from "./SelectedLabelFilter.vue?vue&type=script&lang=ts&"
import style0 from "./SelectedLabelFilter.vue?vue&type=style&index=0&id=73027f96&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73027f96",
  null
  
)

export default component.exports